// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/list.css
// module id = 863
// module chunks = 41